/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;



//////////////////
// WEBPACK FOOTER
// ./~/form-data/lib/browser.js
// module id = T90t
// module chunks = 1